module.exports = __webpack_public_path__ + "static/media/neverlosework-icon.35ef93ec.png";